var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('ticket-gygl',{attrs:{"method-name":'getAllMyManagedOrderLists',"show-status-tab":true,"show-header-type":true,"show-header-user":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }